import * as React from "react";
const Maximize = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M10.2867,13.0059 L10.9937,13.7129 L5.7007,19.0059 L9.9937,19.0059 L9.9937,20.0059 L3.9937,20.0059 L3.9937,14.0059 L4.9937,14.0059 L4.9937,18.2989 L10.2867,13.0059 Z M20,4 L20,10 L19,10 L19,5.707 L13.707,11 L13,10.293 L18.293,5 L14,5 L14,4 L20,4 Z" }));
Maximize.displayName = "Maximize";
var Maximize_default = Maximize;
export {
  Maximize_default as default
};
